import { UserStatusResponse } from "../interfaces";

export async function checkUserStatus(
  username: string,
  pageName: string,
): Promise<UserStatusResponse> {
  const response = await fetch("/api/dice/user-management/v1/users/status", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, pageName }),
  });

  if (!response.ok) {
    throw new Error(`status error: ${response.status}`);
  }

  return response.json();
}
